import React, { PropTypes } from 'react'

import './Day.scss'
import LabeledIcon from 'components/LabeledIcon'
import { formatDate } from 'utils/dates'
import { capitalizeFirstLetter } from 'utils'

const Day = (props) => {
  const {
    selected,
    onClick,
    date
  } = props

  return (
    <LabeledIcon
      selected={selected}
      onClick={onClick}
      label={capitalizeFirstLetter(formatDate('MMM D', date))}
      iconType='text'
      iconContent={capitalizeFirstLetter(formatDate('dd', date))}
      />
  )
}

Day.displayName = 'Day'
Day.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  date: PropTypes.object.isRequired
}
Day.defaultProps = {
  selected: false,
  onClick: () => {}
}

export default Day



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/DateSelector/components/Day/Day.js